/**
 * Retrieve an array of items from firestore response.
 *
 * @param {Firestore Response} querySnapshot
 */
export const getDocs = (querySnapshot) => {
  const docs = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    const { id } = doc;

    docs.push({ id, data });
  });

  return docs;
};

/**
 * Clamps a number between min and max.
 *
 * @param {number} min
 * @param {number} max
 * @param {number} num
 */
export const clamp = function(min, max, num) {
  return Math.min(Math.max(num, min), max);
};
